import React, { useEffect } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import allItems from '../data/index';

function GalleryItem() {
  const { itemId } = useParams();
  const { pathname } = useLocation();
  const itemIdx = allItems.findIndex(item => item.id === itemId);
  const item = allItems[itemIdx];

  const nextItem = itemIdx < allItems.length - 1 ? allItems[itemIdx + 1] : null;
  const prevItem = itemIdx > 0 ? allItems[itemIdx - 1] : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (!item) {
    return (
      <div className="gallery-item">
        <Link to="/gallery" className="gallery-item__back-link">
          ← Back to Gallery
        </Link>
        <h1 className="section-title">Item not found</h1>
        <p className="content-text">Sorry, this gallery item could not be found.</p>
      </div>
    );
  }

  const { title, details, variations } = item;
  

  return (
    <div className="gallery-item">
      <Link to="/gallery" className="gallery-item__back-link">
        ← Back to Gallery
      </Link>

      <h1 className="section-title">{title}</h1>

      <div className="gallery-item__content">
        <p className="gallery-item__description content-text">
          {details}
        </p>
      </div>

      {variations && variations.length > 0 && (
        <div className="gallery-item__variations">
          <div className="gallery-item__variations-grid">
            {variations.map((variation, index) => (
              <div key={index} className="gallery-item__variation">
                <img 
                  src={process.env.PUBLIC_URL + variation.image} 
                  alt={variation.title || `${title} variation ${index + 1}`}
                  className="gallery-item__variation-image"
                />
                {variation.title && (
                  <p className="gallery-item__variation-title">{variation.title}</p>
                )}
                {variation.description && (
                  <p className="gallery-item__variation-description">{variation.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="gallery-item__navigation">
        <Link to={`/gallery/${prevItem !== null ? prevItem.id : null}`} className={`gallery-item__nav-link ${prevItem === null ? 'disabled' : ''}`}>
          &lt; Prev
        </Link>
        <Link to="/gallery" className="gallery-item__nav-link">
          Back to Gallery
        </Link>
        <Link to={`/gallery/${nextItem !== null ? nextItem.id : null}`} className={`gallery-item__nav-link ${nextItem === null ? 'disabled' : ''}`}>
          Next &gt;
        </Link>
      </div>
    </div>
  );
}

export default GalleryItem;
